import request, { PATCH } from '../../utils/request';

export default (body, file) => {
  const fd = new FormData();

  fd.append('request', new Blob([JSON.stringify(body)], { type: 'application/json' }));

  if (file) {
    fd.append('file', file, file.name);
  }

  return request('/ala-agreements', {
    method: PATCH,
    body: fd,
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};
